// extracted by mini-css-extract-plugin
export default {"measure":"NumberInput_measure__IQQVV","shimmer":"NumberInput_shimmer__wHeQm"};